import { useSearchParamState } from '@monorepo/shared/hooks/navigation/useSearchParamState';
import { useHasOrganizationUpdatePermissions } from '@monorepo/shared/hooks/permissions/useHasPermissions';
import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDocumentFoldersList } from '../../hooks/useDocumentFoldersList';
import { Page } from '../styled';
import { FolderFormModal } from './FolderFormModal';
import { FoldersHeader } from './FoldersHeader';
import { FoldersTable } from './FoldersTable';

export function FoldersPage() {
  const { organizationId } = useParams();
  if (!organizationId) {
    throw new Error(
      "Folders page was rendered with url that doesn't have organizationId",
    );
  }

  const canEditOrgSettings =
    useHasOrganizationUpdatePermissions(organizationId);

  const { documentFolders } = useDocumentFoldersList({ organizationId });

  const [filter, setFilter] = useSearchParamState<string>('filter');
  const nonNullFilter = filter ?? '';

  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [scrollToFolderId, setScrollToFolderId] = useState<string | null>(null);
  const handleScrollToFolderHandled = useCallback(
    () => setScrollToFolderId(null),
    [],
  );

  return (
    <Page>
      <FoldersHeader
        filter={nonNullFilter}
        onSearch={setFilter}
        onCreate={() => setIsCreateOpen(true)}
        canCreateFolder={!!canEditOrgSettings}
      />
      <FoldersTable
        filter={nonNullFilter}
        organizationId={organizationId}
        scrollToFolderId={scrollToFolderId}
        onScrollToFolderHandled={handleScrollToFolderHandled}
      />
      {isCreateOpen && canEditOrgSettings && documentFolders && (
        <FolderFormModal
          organizationId={organizationId}
          documentFolders={documentFolders}
          onClose={() => setIsCreateOpen(false)}
          onFolderCreated={setScrollToFolderId}
        />
      )}
    </Page>
  );
}
